Namespace 'Customer.Ticket'

class Customer.Ticket.ConversationHistoryEvent extends Backbone.Model
  # La logica que existe en este modelo se repite en el backend al modelo TicketExportable
  # Tenerlo en cuenta al momento de modificar algo

  isAssigned: =>
    @get('status') == 'Assigned'

  isUnassigned: =>
    @get('status') == 'Not Assigned'

  created_at: =>
    timestamp = @get('timestamp')
    return parseInt(timestamp, 10) if timestamp
    @get('date')

  message: =>
    if @_isUserCreationEvent()
      user = @get('user')
      text = " #{I18n.t('customer.dashboard.conversations.details.history.user_create')} #{@_description()}"
    else if @_isKeepconCreationEvent()
      user = 'Keepcon'
      text = " #{I18n.t('customer.dashboard.conversations.details.history.create')} #{@_description()}"
    else if @_isWebchatFinalizedEvent()
      user = ''
      text = "#{@_actions()}"
    else if @_isAutomaticCutEvent()
      user = 'Keepcon'
      actionText = " #{ I18n.t('customer.dashboard.conversations.details.history.ticket_cut') }"
      causeText = " #{I18n.t('customer.dashboard.conversations.details.history.robot_changes.automatic_rule') }"
      text = actionText + causeText
    else
      user = @get('user')
      text = " #{@_actionsText()}"
      return if text == ' '
    "<span class='user'>#{user}</span>#{text}"

  uniqueId: =>
    'status_event' + @get('id')

  _actionsText: =>
    return @get('action') unless @get('type') is 'conversation_event'
    actionsText = @_enumerateActions @_actions()
    if actionsText && @_isAutomaticEvent() && !@_isWebchatFinalizedEvent() && !@_isPriorityChangeEvent()
      actionsText = [actionsText, @_description()].join(' ')
    actionsText

  _actions: ->
    action for action in [
      @_createWebchatFinalizedEvent() if @_isWebchatFinalizedEvent()
      @_statusChangeEvent() if @get('status_changed')
      @_statusCutEvent() if @_isCutEvent()
      @_assignationChangedEvent() if @get('assignation_changed')
      I18n.t 'customer.dashboard.conversations.details.history.like' if @get('like')
      I18n.t 'customer.dashboard.conversations.details.history.unlike' if @get('unlike')
      I18n.t 'customer.dashboard.conversations.details.history.response' if @get('response')
      I18n.t 'customer.dashboard.conversations.details.history.forward' if @get('forward')
      I18n.t 'customer.dashboard.conversations.details.history.follow' if @get('follow')
      I18n.t 'customer.dashboard.conversations.details.history.retweet' if @get('retweet')
      I18n.t 'customer.dashboard.conversations.details.history.react' if @get('react_love')
      I18n.t 'customer.dashboard.conversations.details.history.unreact' if @get('unreact_love')
      @_createNoteEvent() if @get('note_created')
      @_modifyNoteEvent() if @get('note_modified')
      @_deleteNoteEvent() if @get('note_deleted')
      @_scheduledEvent() if @get('event_type') is 'Scheduled'
      @_editScheduleEvent() if @get('event_type') is 'Edit schedule'
      @_scheduleTimeout() if @get('event_type') is 'Schedule timed up'
      @_priorizationEvent() if @_isPriorityChangeEvent()
      @_surveyProcessStartingEvent() if @_isASurveyProcessStartingEvent()
      @_surveyProcessEndingEvent() if @_isASurveyProcessEndingEvent()
      @_ticketAttributeCreatedEvent() if @_isTicketAttributeCreatedEvent()
      @_ticketAttributeDeletedEvent() if @_isTicketAttributeDeletedEvent()
      I18n.t 'customer.dashboard.conversations.details.history.unscheduled' if @get('event_type') is 'Unscheduled'
    ] when action?

  _enumerateActions: (actions) ->
    return '' if !actions || actions.length == 0
    return actions[0] if actions.length == 1
    connector = " #{I18n.t 'customer.dashboard.conversations.details.history.and'} "
    [actions.slice(0, -1).join(', '), actions.slice(-1)[0]].join(connector)

  _statusChangeEvent: ->
    changeStatus = I18n.t('customer.dashboard.conversations.details.history.change_status')
    "#{changeStatus} <span class='status'>#{@_statusName()}</span>"

  _statusCutEvent: ->
    I18n.t('customer.dashboard.conversations.details.history.ticket_cut')

  _statusName: ->
    I18n.t('customer.dashboard.conversations.status.' + @get('status').replace(/\s+/g, '_').toLowerCase())

  _assignationChangedEvent: ->

    if @get('assigned_user') && @get('assigned_group')
      user = "<span class='user'>#{@get('assigned_user')}</span>"
      group = "<span class='user'>#{@get('assigned_group')}</span>"
      I18n.t('customer.dashboard.conversations.details.history.change_assigned_user_and_group', {user, group})
    else if @get('assigned_user')
      user = "<span class='user'>#{@get('assigned_user')}</span>"
      I18n.t('customer.dashboard.conversations.details.history.change_assigned_user', {user})
    else if @get('assigned_group')
      group = "<span class='user'>#{@get('assigned_group')}</span>"
      I18n.t('customer.dashboard.conversations.details.history.change_assigned_group', {group})

  _createNoteEvent: ->
    @_noteEvent 'add_note'

  _modifyNoteEvent: ->
    @_noteEvent 'mod_note'

  _deleteNoteEvent: ->
    @_noteEvent 'del_note'

  _noteEvent: (text) ->
    formattedText = I18n.t "customer.dashboard.conversations.details.history.#{text}"
    formattedNote = "'#{@get('description')}'"
    [formattedText, formattedNote].join(': ')

  _priorizationEvent: ->
    formattedText = I18n.t('customer.dashboard.conversations.details.history.changed_priority')
    connector = I18n.t('customer.dashboard.conversations.details.history.to')
    priorityTransition = "'#{@get('priority_before')}'" + ' ' + connector +  ' ' + "'#{@get('priority_now')}'"
    prioritizationText = formattedText + ' ' + priorityTransition
    return prioritizationText if @get('description') == ''
    description = @get('description')
    if description.startsWith('customer.dashboard.conversation')
      prioritizationText += ' ' + I18n.t(description)
    else
      usingRule = I18n.t('customer.dashboard.conversations.details.history.using_rule', {description})
      prioritizationText += " #{usingRule}"

  _surveyProcessStartingEvent: ->
    I18n.t('customer.dashboard.conversations.details.history.survey_process_started')

  _surveyProcessEndingEvent: ->
    I18n.t('customer.dashboard.conversations.details.history.survey_process_ended')

  _scheduledEvent: ->
    @_scheduleEvent 'scheduled'

  _editScheduleEvent: ->
    @_scheduleEvent 'edit_schedule'

  _scheduleTimeout: ->
    @_scheduleEvent 'schedule_timeout'

  _scheduleEvent: (text) ->
    [date, note] = @get('description').split(' - ')
    formattedText = I18n.t("customer.dashboard.conversations.details.history.#{text}")
    return formattedText unless date
    formattedDate = moment(date).format 'DD MMM YYYY - hh:mm A'
    scheduleNotes = I18n.t('customer.dashboard.conversations.details.history.schedule_notes')
    formattedNote = if note then "#{scheduleNotes}: #{note}" else ''
    "#{formattedText} #{formattedDate} #{formattedNote}"

  _createWebchatFinalizedEvent: ->
    if (@get('description') == '')
      closedWebchat = I18n.t('customer.dashboard.conversations.webchat_messages.closed_webchat')
      "<span class='user'>#{@get('user')} #{closedWebchat}</span>"
    else
      "<span class='user'>#{@_description()}</span>"

  _ticketAttributeEventMessage: (translation) ->
    formattedName = "<span class='custom-attribute-name'>#{@get('fields').attribute_name}</span>"
    formattedValue = "<span class='custom-attribute-value'>#{@_attributeValue()}</span>"
    I18n.t translation, name: formattedName, value: formattedValue

  _ticketAttributeCreatedEvent: ->
    @_ticketAttributeEventMessage('monitoring.conversation_attributes.description.add_message')

  _ticketAttributeDeletedEvent: ->
    @_ticketAttributeEventMessage('monitoring.conversation_attributes.description.delete_message')

  _attributeValue: ->
    switch @get('fields').attribute_type
      when 'Boolean' then @_booleanAttributeValue()
      when 'HierarchicalTags' then @get('fields').attribute_value[0].join(' -> ')
      else  @get('fields').attribute_value

  _booleanAttributeValue: ->
    if @get('fields').attribute_value
      I18n.t('monitoring.rules.active_yes')
    else
      I18n.t('monitoring.rules.active_no')

  _description: ->
    """
    Warning: the event.description field currently has multiple meanings:
      * Stores note contents for Note and Schedule events
      * Stores a 'cause' for automatic (keepcon) events. E.g. "because there's a new interaction"
    It needs to be processed in different ways depending on these factors.
    """
    description = @get('description')
    return '' unless description and not @_isASurveyProcessEvent()
    " #{I18n.t(description, defaultValue: description)}"

  _isAutomaticEvent: ->
    @get('user').toLowerCase() is 'keepcon'

  _isKeepconCreationEvent: ->
    @get('is_creation_event')

  _isUserCreationEvent: ->
    @get('type') is 'conversation_event' and @get('action') is 'Create'

  _isWebchatFinalizedEvent: ->
    @get('event_type') is 'Webchat finalized'

  _isPriorityChangeEvent: ->
    @get('event_type') is 'Priority changed'

  _isASurveyProcessStartingEvent: ->
    @get('description') is 'Survey process began'

  _isASurveyProcessEndingEvent: ->
    @get('description') is 'Survey process ended'

  _isASurveyProcessEvent: ->
    @_isASurveyProcessEndingEvent()

  _isCutEvent: ->
    @get('ticket_cut')

  _isAutomaticCutEvent: =>
    @get('fields')?['is_automatic_ticket_cut']

  _isTicketAttributeCreatedEvent: ->
    @get('event_type') is 'Ticket attribute created'

  _isTicketAttributeDeletedEvent: ->
    @get('event_type') is 'Ticket attribute deleted'



class Customer.Ticket.ConversationHistoryEventCollection extends Backbone.Collection
  model: Customer.Ticket.ConversationHistoryEvent
